import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";
import { indexRedirectRoute } from "../legacy-redirects";

export const marketingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Attribution", {
          context: "merchant settings label for marketing attribution",
        });
      },
      permission: settingsPagePermission("marketing/attribution"),
    },
    path: "attribution",
    lazy: async () => {
      const { AttributionSettingsPage } =
        await import("../../../../setting/attribution/attribution-settings");
      return { Component: AttributionSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Audience", {
          context: "merchant settings label for marketing audiences",
        });
      },
      permission: settingsPagePermission("marketing/audience"),
    },
    path: "audience",
    lazy: async () => {
      const { AudienceSettingsPage } =
        await import("../../../../setting/marketing/audience-settings");
      return { Component: AudienceSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Email domain", {
          context: "merchant settings label for the marketing email domain",
        });
      },
      permission: settingsPagePermission("marketing/email-domain"),
    },
    path: "email-domain",
    lazy: async () => {
      const { EmailDomainPage } =
        await import("../../../../setting/marketing/email-domain/email-domain");
      return { Component: EmailDomainPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Integrations", {
          context: "merchant settings breadcrumb for marketing integrations",
        });
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "marketing-integrations",
    children: [
      indexRedirectRoute(({ paths }) => `${paths.settings}/integrations`),
      {
        handle: {
          get breadcrumb() {
            return t("Orders API Documentation");
          },
          permission: SettingsPermissions.SET_MARKETING_SETTINGS,
        },
        path: "orders-api-documentation",
        lazy: async () => {
          const { OrdersApiDocumentation } =
            await import("../../../../setting/marketing/integrations/orders-api-documentation");
          return { Component: OrdersApiDocumentation };
        },
      },
    ],
  },
  {
    handle: {
      get breadcrumb() {
        return t("Keywords", {
          context: "merchant settings label for SMS subscription keywords",
        });
      },
      permission: settingsPagePermission("marketing/keywords"),
    },
    path: "subscribe-keywords",
    lazy: async () => {
      const { SubscribeKeywordsTable } =
        await import("../../../../setting/marketing/subscribe-keywords/subscribe-keywords");
      return { Component: SubscribeKeywordsTable };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("{{productName}}", {
          productName: "Marketing Agent",
          context:
            "merchant settings label containing the official Marketing Agent product name",
        });
      },
      permission: settingsPagePermission("marketing/marketing-agent"),
    },
    path: "marketing-agent",
    lazy: async () => {
      const { MarketingAgentSettingsPage } =
        await import("@redotech/redo-merchant-marketing-app/marketing-agent/marketing-agent-settings-page");
      return { Component: MarketingAgentSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Offer page configuration", {
          context:
            "merchant settings page heading for the marketing offer page",
        });
      },
      permission: settingsPagePermission("marketing/offer-page"),
    },
    path: "offer-page-configuration",
    lazy: async () => {
      const { OfferPageConfigurationPage } =
        await import("../../../../setting/marketing/offer-page-configuration");
      return { Component: OfferPageConfigurationPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return "Recover";
      },
      permission: settingsPagePermission("marketing/recover"),
    },
    path: "recover-settings",
    lazy: async () => {
      const { RecoverSettingsPage } =
        await import("../../../../setting/recover/recover-settings");
      return { Component: RecoverSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("SMS Marketing", {
          context: "merchant settings page heading for SMS marketing",
        });
      },
      permission: settingsPagePermission("marketing/sms"),
    },
    path: "sms-marketing",
    lazy: async () => {
      const { SmsSettingsPage } =
        await import("../../../../setting/marketing/sms-settings");
      return { Component: SmsSettingsPage };
    },
  },
];
